import type { EmailBlockType, EmailTheme } from "../types";

export const BLOCK_PALETTE: { type: EmailBlockType; icon: string; label: string }[] = [
  { type: "heading", icon: "title", label: "campaigns.studio_email.block_heading" },
  { type: "text", icon: "notes", label: "campaigns.studio_email.block_text" },
  { type: "image", icon: "image", label: "campaigns.studio_email.block_image" },
  { type: "button", icon: "smart_button", label: "campaigns.studio_email.block_button" },
  { type: "coupon", icon: "confirmation_number", label: "campaigns.studio_email.block_coupon" },
  { type: "products", icon: "grid_view", label: "campaigns.studio_email.block_products" },
  { type: "divider", icon: "horizontal_rule", label: "campaigns.studio_email.block_divider" },
  { type: "spacer", icon: "height", label: "campaigns.studio_email.block_spacer" },
  { type: "social", icon: "share", label: "campaigns.studio_email.block_social" },
  { type: "footer", icon: "call_to_action", label: "campaigns.studio_email.block_footer" },
];

export const blockLabel = (type: EmailBlockType) =>
  BLOCK_PALETTE.find((b) => b.type === type)?.label ?? type;

export const FONT_STACKS: Record<EmailTheme["font"], string> = {
  sans: "'Helvetica Neue', Helvetica, Arial, sans-serif",
  serif: "Georgia, 'Times New Roman', serif",
  rounded: "'Trebuchet MS', 'Segoe UI', sans-serif",
};

export const THEME_PRESETS: { name: string; theme: Partial<EmailTheme> }[] = [
  { name: "Terracotta", theme: { brand_color: "#e76f51", background_color: "#f4f1ea", text_color: "#1f2937" } },
  { name: "Espresso", theme: { brand_color: "#6f4e37", background_color: "#efe8df", text_color: "#2b2118" } },
  { name: "Matcha", theme: { brand_color: "#4f772d", background_color: "#eef3e6", text_color: "#1c2b12" } },
  { name: "Midnight", theme: { brand_color: "#4361ee", background_color: "#e9ecf5", text_color: "#111827" } },
];

// MIME type used for palette → canvas and canvas reorder drags.
export const DRAG_NEW = "application/x-lemmon-email-new";
export const DRAG_MOVE = "application/x-lemmon-email-move";
